import React from "react"

import Layout from "../components/allstar/layout"

import SectionBody from "../components/allstar/methodology/section-body"
import { graphql } from "gatsby"

const MethodologyPage = props => {
  return (
    <Layout location={props.location} title={"Methodology"}>
      <SectionBody data={props.data} location={props.location} />
    </Layout>
  )
}

export default MethodologyPage

export const query = graphql`
  query methodologyPage {
    allBadges: allFile(
      filter: { relativeDirectory: { eq: "allstar/badges" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
